import React from "react";
import { Container } from "react-bootstrap";
import Dashboard from "../components/AdminDashboard";
import CustomHelmet from "../components/CustomHelmet";

const AdminDashboard = (props) => {
  return (
    <>
      <CustomHelmet page="Admin Dashboard" />
      <Dashboard page="Dashboard">
        <Container>
          <h3 className="my-3">Welcome, Admin</h3>
          <a
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link"
            href="https://www.hubsquares.com/php_files/export.php/"
          >
            <button className="btn btn-danger btn-lg addbtn">
              <span>Export Users</span>
            </button>
          </a>
        </Container>
      </Dashboard>
    </>
  );
};
export default AdminDashboard;
